// extracted by mini-css-extract-plugin
module.exports = {"root":"blogVideo_root__V703o","player":"blogVideo_player__kxIYQ","links":"blogVideo_links__q0ZFq"};